import React from "react";
import { Field, FieldArray } from "formik";
import moment from "moment";
import {
  LabeledDatePicker,
  Input,
  Select,
} from "../../../../../components/formik";
import { withError } from "../../../../../components/hocs";
import { Col, Row } from "reactstrap";

const ErrorInput = withError(Input);
const ErrorSelect = withError(Select);
const LegalEntityFormFields = ({ countries }) => (
  <React.Fragment>
    <Row>
      <Col lg={5} className="pl-0">
        <Field
          placeholder="Company name"
          name="name.fullName"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <LabeledDatePicker
              dateFormat="dd.MM.yyyy"
              changeOnInput={true}
              placeholderText="Date of est. (dd.mm.yyyy)"
              label=""
              name="birthDate"
              maxDate={new Date(moment())}
              minDate={new Date(1900, 0, 1)}
              yearDropdownItemNumber={150}
            />
          </Col>
          <Col lg={6} className="pr-0">
            <FieldArray name="identifications">
              <Field
                placeholder="Company number"
                name="identifications[0].number"
                component={ErrorInput}
              />
            </FieldArray>
          </Col>
        </Row>
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5} className="pl-0">
        <Field
          placeholder="Company type"
          name="companyType"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="City"
              name="addresses[0].city"
              component={Input}
            />
          </Col>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="Post code"
              name="addresses[0].postalCode"
              component={Input}
            />
          </Col>
        </Row>
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5} className="pl-0">
        <FieldArray name="addresses">
          <Input
            placeholder="Headquaters and Management Address"
            name="addresses[0].headquaters"
          />
        </FieldArray>
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="Country"
              name="addresses[0].countryId"
              className="dropdown-group"
              options={countries}
              component={ErrorSelect}
            />
          </Col>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="Region"
              name="addresses[0].region"
              component={Input}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </React.Fragment>
);

export default LegalEntityFormFields;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/upsert-watch-list-entry-form/legal-entity-form-fields/LegalEntityFormFields.jsx